import {
  Artwork,
  UserId,
  ObjectIdAsHexString,
} from "kreate-common/modules/business-types";
import { z } from "zod";

import { BooleanField } from "../../utils/customType";

export const Params = z.object({
  createdBy: UserId.optional(),
  collectionId: ObjectIdAsHexString.optional(),
  curatedCollectionId: ObjectIdAsHexString.optional(),
  searchQuery: z.string().optional(),
  artworkIds: z.string().array().optional(),
  isSingleEdition: BooleanField.optional(),
  isOwnerVerified: BooleanField.optional(),
  mintStatus: z
    .enum(["available_for_minting", "sold_out", "all"])
    .default("all"),
  offset: z.coerce.number(),
  limit: z.coerce.number(),
  orderBy: z
    .enum([
      "last_updated",
      "popular",
      "minting_price",
      "recently_loved",
      "recently_commented",
    ])
    .default("last_updated"),
  orderDirection: z
    .union([z.literal("asc"), z.literal("desc")])
    .default("desc"),
});

export type Params = z.infer<typeof Params>;

export const ArtworkResult = Artwork;
export type ArtworkResult = Artwork;

export const Result = z.object({
  artworks: ArtworkResult.array(),
  count: z.number(),
});

export type Result = z.infer<typeof Result>;

export type GetArtworkList$Params = Params;
export const GetArtworkList$Params = Params;
export type GetArtworkList$Result = Result;
export const GetArtworkList$Result = Result;
